import React from "react";

const ExpandedCaption = ({ caption, onCollapse }) => {
  const [touchStartY, setTouchStartY] = React.useState(null);
  const [touchCurrentY, setTouchCurrentY] = React.useState(null);

  const handleTouchStart = (e) => setTouchStartY(e.touches[0].clientY);
  const handleTouchMove = (e) => setTouchCurrentY(e.touches[0].clientY);
  const handleTouchEnd = () => {
    if (
      touchStartY !== null &&
      touchCurrentY !== null &&
      touchCurrentY - touchStartY > 50
    ) {
      onCollapse();
    }
    setTouchStartY(null);
    setTouchCurrentY(null);
  };

  return (
    <div
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{
        maxHeight: "10vh",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.6))",
        borderRadius: "8px",
        color: "white",
        overscrollBehavior: "contain",
      }}
    >
      <style>{`
        .hide-scrollbar {
          overflow-y: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <div className="hide-scrollbar" style={{ flex: 1 }}>
        <p style={{ padding: "2px", textAlign: "left", whiteSpace: "pre-wrap" }}>
          {caption}
        </p>
      </div>
      <div style={{ padding: "8px", margin: 0, textAlign: "left", }}>
        <button
          onClick={onCollapse}
          style={{
            background: "transparent",
            color: "#fff",
            border: "none",
            fontSize: "14px",
            fontWeight: "bold",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          less
        </button>
      </div>
    </div>
  );
};

export default ExpandedCaption;